import { render, staticRenderFns } from "./lh2index.vue?vue&type=template&id=2a5263e4&scoped=true&"
import script from "./lh2index.vue?vue&type=script&lang=js&"
export * from "./lh2index.vue?vue&type=script&lang=js&"
import style0 from "./lh2index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./lh2index.vue?vue&type=style&index=1&id=2a5263e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5263e4",
  null
  
)

export default component.exports